<template>
    <div class="accessIndex">
      <section class="dashboard__by_date">
        <p class="dashboard__general--title">Usuarios (Generación de pin)</p>
        <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
          <v-layout
            v-if="fase==0"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs2>
            </v-flex>
            <v-flex xs8 style="">
              <v-text-field
                v-model="rut"
                style="margin-top:30px"
                label="Cédula"
                required
                placeholder="Cédula"
                @keypress="isRutValid($event)"
                :rules="[rules.required, rules.affair,rules.rut]"
                counter="20">
              </v-text-field>
            </v-flex>

            <v-flex xs4  style="margin-left:33%!important">
              <v-btn
                type="button"
                outline
                color="#353545"
                style="width: 100%;margin-top:20px; "
                @click="validateFingerprint()"
                :disabled="!valid || !rut">
                Generar Pin
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==1"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Estado del proceso:</b>
              </p>
              <p style="text-align:center;font-size:20px;margin-top:20px">
               <b> <i>{{fase1Status}}</i>  </b>
              </p>
              <p style="text-align:center;font-size:15px">
                <i>Hacer click en iniciar lector. (Servicio en segundo plano ejecutándose)</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:0%"
            @click="closeSignUpFingerprint();newPin();"
            >Regresar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==2"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Estado del proceso:</b>
              </p>
              <p style="text-align:center;font-size:20px;margin-top:20px">
               <b> <i>{{fase2Status}}</i>  </b>
              </p>
              <p style="text-align:center;font-size:15px">
                <i>Hacer click en iniciar lector. (Servicio en segundo plano ejecutándose)</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:0%"
            @click="closeValidateFingerprint();newPin()"
            >Regresar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==3"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:30px">
                <i>{{pin}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==-1"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:15px">
                <i>{{myError}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:30px">
                <i>{{pin}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
        </v-form>
    </section>
    </div>
</template>

<script>
import md5 from 'js-md5';
import extra from './../../../../vue/additionalData/mixData.js';
export default {
  data(){
    return{
      rut:'',
      pin:[],
      rules: {
          required: value => (value&&value.length>0) || 'Este campo es obligatorio',
          affair: value => value.length <= 20 || 'Máximo 20 caracteres',
          rut: value => {
                if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de Rut incorrecto'}else{return 'El Rut debe tener al menos 7 caracteres'}},
      },
      valid: false,
      fase:0,
      faseError:0,
      myError:'',
      fase1Status:'Registrando huella de usuario',
      fase2Status:'Validando huella de usuario'
    }
  },

  methods:{
    isRutValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && evt.key.toUpperCase()!="K") {
            evt.preventDefault();;
        } else {
            return true;
        }
    }, 

    newPin(){
      this.rut=''
      this.pin=[]
      this.fase=0;
      this.faseError=0;
      this.fase1Status='Registrando huella de usuario';
      this.myError="";      
    },
    validateFingerprint(){
      var self=this;
      try {
        this.$http.get('fingerprints/get_user_fingerprint',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          },
          params:{
            location_id: localStorage.getItem("location_id"),
            rut:self.rut
          }
        })
        .then(async function(response){
          var fingerprint = response.body.data
          if (response.body.fingerprint_active){
            if(fingerprint&&!response.body.error){            
              await self.downloadFingerprint(fingerprint,self.rut);
              self.fase=2;

              self.openCompareFingerprint();
            }else if(!fingerprint&&!response.body.error){
              self.fase=1;
              self.openSignUpFingerprint();
            }else{
              self.fase=-1;
              self.faseError=0;
              self.myError=fingerprint;
            }
          }else{
            self.generatePin();
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              self.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              self.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {        
        self.updateAlertMessage(e.message)
        self.updateIsInAlert(true)        
      }
    },
    generatePin(){
      var self=this;
      try {
        this.$http.get('get_user_pin',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          },
          params:{
            location_id: localStorage.getItem("location_id"),
            rut:self.rut
          }
        })
        .then(function(response){
          self.pin = response.body.data
          // self.isInError=response.body.error
          self.fase=3;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
       self.updateAlertMessage(e.message)
       self.updateIsInAlert(true) 
      }
    },
    openSignUpFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Enrollment_Control.txt"
      var writeStream = fs.createWriteStream(filePathReg);
      writeStream.on('error', function (err) {
        console.log(err);
      });
      writeStream.write("1");
      writeStream.end();
      this.waitFingerprintResponse(fs)
    },
    async closeSignUpFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Enrollment_Control.txt"
      var writeStream2 = fs.createWriteStream(filePathReg);
      writeStream2.on('error', function (err) {
        console.log(err);
      });
      writeStream2.write("0");
      writeStream2.end();
    },
    async closeValidateFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Verification_Control.txt"
      var writeStream3 = fs.createWriteStream(filePathReg);
      writeStream3.on('error', function (err) {
        console.log(err);
      });
      writeStream3.write("0");
      writeStream3.end();
    },
    async waitFingerprintResponse(fs){
      var vm = this
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      var filePathControl=filePath+"Enrollment_Status.txt"
      var filePathFingerpint=filePath+"Fingerprints/A_.fpt"
      await new Promise(function(resolve, reject) {
        var fsWait = false;
        var watcher=fs.watch(filePathControl, async (event, filename) => {
          try{
            if (filename) {
              if (fsWait) return;
              fsWait = setTimeout(() => {
                fsWait = false;
              }, 100);
              var a= fs.readFileSync(filePathControl)
              // console.log(`${filename} file Changed`);
              if(a.toString()!=0){
                // console.log("CAMBIO:",a.toString())
                if(a.toString()==1){
                  var r_finger= await fs.readFileSync(filePathFingerpint)
                  // console.log("MY DOCUMENT")
                  // console.log(r_finger)
                  // var fileFinger=new File(r_finger, "A_.fpt" );   
                  var fileFinger = new Blob([r_finger], {type:'text/plain;charset=UTF-16LE;'});               
                  var my_fingerprint=null
                  var reader= new FileReader()
                  reader.readAsDataURL(fileFinger);
                  reader.onload = async function(){
                    my_fingerprint=reader.result;
                    var myData={
                      attributes:{  
                        rut: vm.rut,
                        encrypted_code: my_fingerprint
                      }
                    }
                    // console.log(my_fingerprint)
                    // console.log(myData)
                    vm.fase1Status='Enviando huella al servidor...'
                    await vm.sendFingerPrint(myData,vm)    
                  }                             
                }else{
                  self.updateAlertMessage("Error al registrar la huella, vuelva a intentarlo")
                  self.updateIsInAlert(true) 
                }           
                
                watcher.close()
                resolve()
              }
            
            }
          }catch(e){ watcher.close();console.log(e);reject()} 
        });
      });
    },
    openCompareFingerprint(fingerprint){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      let filePathControl=filePath+"Verification_Control.txt"
      var writeStream = fs.createWriteStream(filePathControl);
      writeStream.on('error', function (err) {
        console.log(err);
      });
      writeStream.write("1");
      writeStream.end();
      
      this.waitFingerprintComparation(fs)
    },
    
    async waitFingerprintComparation(fs){
      var vm = this
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      var filePathControl=filePath+"Verification_Status.txt"

      await new Promise(function(resolve, reject) {
        var fsWait = false;
        var ansWatcher=fs.watch(filePathControl, async (event, filename) => {
          try{
            if (filename) {
              if (fsWait) return;
              fsWait = setTimeout(() => {
                fsWait = false;
              }, 100);
              var a= fs.readFileSync(filePathControl)
              // console.log(`${filename} file Changed`);
              if(a.toString()!=0){
                // console.log("CAMBIÓ A:",a.toString())
                
                if(a.toString()==1){
                  // console.log("VALIDACIÓN CORRECTA")  
                  vm.generatePin();                
                }else if(a.toString()==2){
                  vm.fase=-1
                  vm.faseError=2;
                  vm.myError="La huella ingresada no corresponde a la de este usuario"                                                 
                }else if(a.toString()==-1){
                  vm.fase=-1
                  vm.faseError=2;
                  vm.myError="Error en el aplicativo de huella, reíntente por favor."                                                 
                }else{
                  console.log("VALOR INCORRECTO REVISE EL APLICATIVO")
                }                           
                ansWatcher.close()
                resolve()
              }
            
            }
          }catch(e){ console.log(e);ansWatcher.close();reject()} 
        });
      });
    },
    sendFingerPrint(fingerprint,vm){  
      
      return new Promise(function(resolve, reject) {
        try {  
          console.log(fingerprint)        
          vm.$http.post('fingerprints',{
            data: vm.encrypt(fingerprint).toString()
          },{
            headers: {
              "X-Device-ID" : vm.getDeviceId(),
              "Authorization" : 'Bearer ' + vm.getUserToken()
            }
          }).then(function(response){
            // console.log("FUNCIONAAAA")
            // console.log(response)  
            vm.generatePin()   
            if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
            resolve()
          }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            console.log("ERROR EN PETICIÓN")
            console.log(response);
            vm.fase=-1
            self.faseError=1;
            self.myError="Error en el envío de la huella";
            reject()

          })
        } catch (e) {
          console.log("ERROR EN PETICIÓN")
          console.log(e)
          vm.fase=-1
          self.faseError=1;
          self.myError="Error en el envío de la huella";
          reject()

        }
      })
    }
  },
  created(){
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/PinGenerator.vue